module.exports = __webpack_public_path__ + "static/installationspartner-extraimg2@2x-min-ab0d1cba58ce9f81e439c3a3351ae11b.png";